import styled from "styled-components"

export const Section = styled.section`
  background: #000;
  margin-left: -1px;
  margin-right: -1px;
  padding: 25px 0px;
  @media (min-width: 999px) {
    padding: 100px 0px;
  }
`

export const Container = styled.div`
  max-width: 800px;
  display: flex;
  flex-direction: row;
  align-content: center;
  align-items: center;
  justify-content: center;
  margin: auto;
  @media (max-width: 999px) {
    padding: 20px;
  }
`

export const Icon = styled.svg`
  width: 18px;
  height: 18px;
  margin: 0px 15px;
`
export const Enlace = styled.a`
  color: white;
`
export const Title = styled.h2`
  padding: 8px 0;
  margin: 0;
  color: #FFFFFF;
  text-align: center;
`
export const Paragraph = styled.p`
  font-size: 16px;
  color: #ffffff;
  text-align: center;
`
export const Logo = styled.svg`
  flex: none;
  align-items: center;
  fill: #FFFFFF;
  transition: fill 0.25s;
  width: 100px;
  margin: auto;
  padding-bottom: 10px;
  @media (min-width: 999px) {
    width: 120px;
  }
`
